import { render, staticRenderFns } from "./UsuarioManter.vue?vue&type=template&id=c2fc0ce4&"
import script from "./UsuarioManter.vue?vue&type=script&lang=js&"
export * from "./UsuarioManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports